import { type FC, useMemo } from 'react';
import { motion } from 'motion/react';
import { clsx } from '@team/clsx';
import { type Props } from './types';
import css from './style.module.css';

const animate = { width: 'auto' };
const transition = { duration: 0.3, easing: 'ease-out' };

export const Entry: FC<Props> = ({
  className,
  initialSize = 'auto',
  shouldAnimate = true,
  onAnimationComplete,
  children,
}) => {
  const style = useMemo(() => ({ width: initialSize }), [initialSize]);

  return (
    <motion.div
      className={clsx(className, css.root)}
      initial={shouldAnimate}
      style={style}
      animate={animate}
      transition={transition}
      onAnimationComplete={onAnimationComplete}
    >
      {children}
    </motion.div>
  );
};
